<template>
    <div class="dap-transaction" ref="summary" v-if="getTransactions && getTransactions.length">
        <div class="f3 text-bold" >Past Transaction Summary</div>
        <div class="table-scroll">
            <table class="table">
                <thead>
                    <tr>
                        <th>City</th>
                        <th>Transactions</th>
                        <th>Avg Sale Price</th>
                        <th>Last Close</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in getTransactions">
                        <td class="text-capitalize">
                            <div>{{item.city}}</div>
                        </td>
                        <td>
                            <div>{{item.count}}</div>
                        </td>
                        <td>
                            <div>{{$filters.formatFriendlyPrice(item.averageSalePrice)}}</div>
                        </td>
                        <td>
                            <div>{{$filters.formatDate(item.lastTransactionDate)}}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <a v-if="transactions.length > 5" class="more link" @click="toggle">{{showMore? 'Show Less' : 'Show More'}}</a>
    </div>
</template>
<script src="./agent-transaction.js"></script>
<style lang="scss">
@use "./agent-transaction.scss" as *;
</style>